(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/frs-donation/components/donor/partials/custom-questions', '<div class="donation-table" data-ng-repeat="question in list.customQuestions">\n' + '  <div data-ng-include="::template(\'questions/\' + question.type)"></div>\n' + '</div>\n' + '');
}]);
})();